import React, { Component } from "react";
import { connect } from "react-redux";
import Checkbox from "../../../../components/Checkbox";
import Input from "../../../../components/Input";
import Wrapper from "../../../../components/Wrapper";
import Select from "../../../../components/Select";
import { checkMinMax, priceNumbers } from "../../../../controllers";
import cloneDeep from "lodash/cloneDeep";
import { natijehDaaviMaliOptions } from "../../../../reducer/selectOptions";
import "./index.css";
import { showPrice } from "../../../../global/functions";

class FinancialClaims extends Component {
  constructor(props) {
    super(props);
    this.state = {
      price: props.mali["mizanMahkoomKhaste"].toLocaleString(),
      tableInput: {
        omooriEjraiiValue: "",
      },
      tableItems: [
        {
          title: "بدوی",
          value: "badvi",
          showPrice: {
            value: "badviCost",
            subsetOf: "footer",
          },
          changePrice: null,
          disable: null,
        },
        {
          title: "تجدید نظر",
          value: "tajdidNazar",
          showPrice: {
            value: "tajdidNazarCost",
            subsetOf: "footer",
          },
          changePrice: null,
          disable: {
            minValue: 30000000,
          },
        },
        {
          title: "دیوان عالی کشور",
          value: "divanAli",
          showPrice: {
            value: "divanAliCost",
            subsetOf: "footer",
          },
          changePrice: null,
          disable: {
            minValue: 20000000,
          },
        },
        {
          title: "امور اجرایی",
          value: "omooriEjraii",
          showPrice: {
            value: "omoorEjraiiCost",
            subsetOf: "footer",
          },
          changePrice: {
            value: "omooriEjraiiValue",
            min: "minEjra",
            max: "maxEjra",
          },
          disable: null,
        },
      ],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { mali, setMali, sendData, setMinMax } = cloneDeep(this.props);
    if (mali.mizanMahkoomKhaste !== prevProps.mali.mizanMahkoomKhaste) {
      setMinMax(0);
    }
    if (JSON.stringify(mali) !== JSON.stringify(prevProps.mali)) {
      sendData("Mali");
    }
    if (mali["mizanMahkoomKhaste"] < 20000000 && mali["divanAli"]) {
      mali["divanAli"] = false;
      setMali(mali);
    }
    if (mali["mizanMahkoomKhaste"] < 30000000 && mali["tajdidNazar"]) {
      mali["tajdidNazar"] = false;
      setMali(mali);
    }
  }

  render() {
    const { price, tableItems, tableInput } = cloneDeep(this.state);
    const { mali, setMali, footer, header, minMax } = cloneDeep(this.props);
    return (
      <Wrapper>
        <header className="flex flex-center py-4">
          <div className="flex align-center">
            <label className="text-normal m-0 ml-2">نتیجه دعوی:</label>
            <Select
              value={mali["natijeDaavi"]}
              setValue={(e) => {
                mali["natijeDaavi"] = Number(e.target.value);
                setMali(mali);
              }}
              label="نتیجه دعوی"
              items={natijehDaaviMaliOptions}
            />
          </div>
        </header>
        <main className="flex column flex-center mt-2">
          <div>
            <div />
            <Input
              value={price}
              onChange={(e) => {
                var value = e.target.value;
                mali["mizanMahkoomKhaste"] = Number(
                  priceNumbers(value).replace(/[^0-9.]/g, "")
                );
                setMali(mali);
                this.setState({ price: priceNumbers(e.target.value) });
              }}
              append="ریال"
              prepend={
                header["tarefeYaGharadad"]
                  ? "میزان محکوم به / خواسته"
                  : "میزان حق الوکاله مورد توافق"
              }
              inputClassName="text-center dir-ltr"
            />
            <div />
          </div>
          <table className="mt-4">
            <tbody>
              {tableItems.map((item, index) => (
                <tr key={index}>
                  <td>
                    <Checkbox
                      value={mali[item.value]}
                      setValue={() => {
                        mali[item.value] = !mali[item.value];
                        setMali(mali);
                      }}
                      disable={
                        item.disable === null
                          ? false
                          : mali["mizanMahkoomKhaste"] < item.disable.minValue
                          ? true
                          : false
                      }
                      title={item.title}
                    />
                  </td>
                  {item.showPrice !== null ? (
                    <td>
                      {showPrice(
                        eval(item.showPrice.subsetOf),
                        item.showPrice.value
                      )}
                    </td>
                  ) : null}
                  {item.changePrice !== null ? (
                    <td>
                      <Input
                        value={tableInput[item.changePrice.value]}
                        onChange={(e) => {
                          mali[item.changePrice.value] = Number(
                            priceNumbers(e.target.value).replace(/[^0-9.]/g, "")
                          );
                          setMali(mali);
                          tableInput[item.changePrice.value] = priceNumbers(
                            e.target.value
                          );
                          this.setState({ tableInput });
                        }}
                        inputClassName="text-center dir-ltr"
                        append="ریال"
                        disabled={!mali[item.value]}
                        error={{
                          show: mali[item.value],
                          color: checkMinMax(
                            mali[item.changePrice.value],
                            minMax[item.changePrice.min],
                            minMax[item.changePrice.max]
                          )
                            ? "success"
                            : "danger",
                          content: `حداقل ${minMax[
                            item.changePrice.min
                          ].toLocaleString()} و حداکثر ${minMax[
                            item.changePrice.max
                          ].toLocaleString()} ریال`,
                        }}
                      />
                    </td>
                  ) : null}
                </tr>
              ))}
            </tbody>
          </table>
        </main>
      </Wrapper>
    );
  }
}

let mapStateToProps = (state) => ({
  mali: state.mali,
  header: state.header,
  footer: state.footer,
  minMax: state.minMax,
});
let mapDispatchToProps = (dispatch) => ({
  setMali: (data) => {
    dispatch({ type: "SET_MALI", data });
  },
  setMinMax: (data) => {
    dispatch({ type: "SET_MINMAX", data });
  },
  sendData: (data) => {
    dispatch({ type: "SEND_DATA", data });
  },
});
export default connect(mapStateToProps, mapDispatchToProps)(FinancialClaims);
